import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import QRCode from 'react-qr-code';
import './../../scss/bank-id-qr-modal.scss';
import { bankidcolor, CloseIcon, rightArrow, ReloadIcon } from '../images/svg/icons';
import { Loadinggif } from '../images/gif/icons';

interface BankIDQRModalProps {
    show: boolean;
    onClose: () => void;
    qrCodeValue?: string | null;
    isLoading?: boolean;
    onReloadQR?: () => void;
    onBack?: () => void;
    customMessage?: string;
    isAuthenticated?: boolean;
    isAuthSuccessful?: boolean;
    isReloadState?: boolean;
}

const BankIDQRModal: React.FC<BankIDQRModalProps> = ({
    show,
    onClose,
    qrCodeValue = null,
    isLoading = false,
    onReloadQR,
    onBack,
    customMessage = '',
    isReloadState
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    if (!show) return null;

    const handleReloadQR = () => {
        onReloadQR?.();
    };

    const handleBack = () => {
        onBack?.();
    };


    return (
        <div className="bankid-qr-overlay">
            <div className="bankid-qr-modal">
                <div className="bankid-qr-content">

                    {/* Header */}
                    <div className="bankid-qr-header">
                        <h2 className="bankid-qr-title mb-3">{t('SIGNING_IN_WITH_BANK_ID')}</h2>
                        <button
                            type="button"
                            className="bankid-qr-close-btn"
                            aria-label="Close"
                            onClick={onClose}
                        >
                            <img src={CloseIcon} alt="Close" width={24} height={24} />
                        </button>
                    </div>

                    <div className="bankid-qr-body">

                        {/* Instructions Row */}
                        <div className="bankid-instruction-row">
                            {onBack && (
                                <button className="bankid-back-btn" onClick={handleBack}>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                        <path
                                            d="M19 12H5M12 19L5 12L12 5"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </button>
                            )}
                            <div className="bankid-instruction-content ">
                                <div className="bankid-icon">
                                    <img src={bankidcolor} width={16} height={16} alt="" />
                                </div>
                                <span className="bankid-instruction-text ">{t("SCAN_QR_FROM_BANK_APP")}</span>
                            </div>
                        </div>

                        {/* QR / Success / Loading */}
                        <div className="bankid-qr-container">
                            {isLoading ? (
                                <img src={Loadinggif} width={200} alt="Loading..." />
                            ) : isReloadState ? (
                                <div className="d-flex justify-content-center align-items-center flex-column gap-3  ">
                                    <div className="mt-4">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100" fill="none">
                                            <path d="M49.99 0C22.4131 0 0 22.41 0 49.988C0 77.566 22.4171 100 49.99 100C77.5669 100 100 77.566 100 49.988C100 22.41 77.5669 0 49.99 0ZM49.99 6.25C74.188 6.25 93.7462 25.789 93.7462 49.988C93.7462 74.187 74.188 93.75 49.99 93.75C25.792 93.75 6.25375 74.188 6.25375 49.988C6.25375 25.788 25.792 6.25 49.99 6.25ZM37.4865 34.367C36.6623 34.3787 35.8733 34.7108 35.2952 35.2967C34.0804 36.5155 34.0804 38.4842 35.2952 39.7029L45.5838 49.9999L35.2952 60.3049C34.0804 61.5237 34.0804 63.4924 35.2952 64.7111C36.5139 65.922 38.4826 65.922 39.7012 64.7111L49.9898 54.4181L60.2744 64.7111C60.8603 65.3009 61.6571 65.6291 62.4891 65.6291C63.3211 65.6291 64.1179 65.3009 64.7038 64.7111C65.9186 63.4923 65.9186 61.5236 64.7038 60.3049L54.4032 49.9999L64.7038 39.7029C65.9186 38.4841 65.9186 36.5154 64.7038 35.2967C64.1179 34.7029 63.3211 34.3709 62.4891 34.367C61.6571 34.3709 60.8603 34.7029 60.2744 35.2967L49.9898 45.5857L39.7012 35.2967C39.1153 34.7029 38.3185 34.3709 37.4865 34.367Z" fill="#F04438" />
                                        </svg>
                                    </div>
                                    <h6 className='text-red my-2'>{t(customMessage)}</h6>
                                </div>
                            )
                                : qrCodeValue ? (
                                    <div className="bankid-qr-code">
                                        <QRCode
                                            value={qrCodeValue}
                                            size={200}
                                            style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
                                            viewBox="0 0 256 256"
                                        />
                                    </div>
                                ) : (
                                    <h1 style={{ color: 'red' }}>QR not available</h1>
                                )}
                        </div>

                        {(isReloadState) && (
                            <div className="bankid-reload-container">
                                <button
                                    className="bankid-reload-btn"
                                    onClick={handleReloadQR}
                                    disabled={isLoading}
                                >
                                    <img src={ReloadIcon} alt="" />
                                    <span>{t('Reload QR')}</span>
                                </button>
                            </div>
                        )}
                    </div>

                </div>
            </div>
        </div>
    );
};

export default BankIDQRModal;